import {Grid} from "@mui/material";
import {styled} from "@mui/material/styles";
import {TabPanel} from "@mui/lab";

export const BookingTabPanel = styled(TabPanel)(() => ({
  paddingLeft: '0',
  paddingRight: '0',
}));

export const TopMargin = styled(Grid)(() => ({
  marginTop: "1rem"
}));
